import { AfterViewInit, Component, ViewChild } from '@angular/core';
import { MetadataLoadingStage, UserContextService } from '../../core/services/user-context.service';
import { OrganizationContactEntityExtended, OrganizationEntity } from 'mj_generatedentities';
import { LogError } from '@memberjunction/core';
import { SharedService } from 'src/app/core/services/shared-service';
import { Router } from '@angular/router';
import { PlanCard, SubscriptionPlanService } from 'src/app/core/services/subscription-plan.service';
import { PriceTableComponent } from 'src/app/shared/price-table/price-table.component';

@Component({
  selector: 'app-pricing',
  templateUrl: './pricing.component.html',
  styleUrl: './pricing.component.css'
})
export class PricingComponent implements AfterViewInit {
  @ViewChild(PriceTableComponent) priceTableComponent!: PriceTableComponent;

  private _organizationContact: OrganizationContactEntityExtended;
  
  constructor(
    private router: Router,
    private userContextService: UserContextService,
    private sharedService: SharedService,
    private planService: SubscriptionPlanService,
  ) {}

  async ngAfterViewInit(): Promise<void> {
    this.userContextService.MetadataLoadingStage$.subscribe(async (loaded) => {
      if (loaded === MetadataLoadingStage.OrganizationLoaded) {
        this._organizationContact = this.userContextService.OrganizationContact;
        await new Promise(resolve => setTimeout(resolve, 500));

        if (this.priceTableComponent) {
          this.priceTableComponent.SetOnSelectionCallback(async (sub: PlanCard, cycleID: string) => {
            await this.handlePlanSelection(sub, cycleID);
          });
        }
      }
    });
  }

  async handlePlanSelection(sub: PlanCard, cycleID: string): Promise<void> {
    try {
      const priceID = sub.PriceData.get(cycleID).PriceID;
      const organizationContactID = this._organizationContact.ID;

      this.router.navigate(['/onboarding/checkout']); // Redirect to checkout page before since we need to wait for the transaction to be initialized
      await this.planService.InitializeTransaction(organizationContactID, priceID);

    } catch (e) {
      const message = 'Failed to handle plan selection';
      LogError(message + `: ${e}`);
      this.sharedService.NoAccessMessage = message;
      this.sharedService.AccessDenied = true;
    }
  }
}
